import './HelpModal.scss'

import React, {Component} from 'react'
import OpButton from 'common/views/components/OpButton'
import { connectModal } from 'redux-modal'
import { Modal } from 'react-bootstrap'
import Script from 'react-load-script'

class Help extends Component {

  constructor(props) {
    super(props)

    this.state = {
      videoOpen: false,
      video: null,
      popOverShow: this.popOverShow.bind(this),
      popOverHide: this.popOverHide.bind(this),
      videoId: "m93qirwnag"
    }
  }

  popOverShow() {
    this.setState({videoOpen:true})
  }

  popOverHide() {
    this.setState({videoOpen:false})
  }

  setVideo = (video) => {
    this.setState({video})
  }

  componentDidMount() {
    window._wq = window._wq || []
    const { setAgentOnboardDate } = this.props
    const { popOverHide, popOverShow, videoId } = this.state
    const setVideo = this.setVideo

    const video = {
      id: videoId,
      onReady: function(video) {
        setVideo(video)
        video.bind("popovershow", popOverShow)
        video.bind("popoverhide", popOverHide)
        video.bind("end", setAgentOnboardDate)
      },

    }
    _wq.push(video)
  }

  componentWillUnmount() {
    const { video, popOverHide, popOverShow } = this.state
    if (video) {
      video.unbind("popovershow", popOverShow)
      video.unbind("popoverhide", popOverHide)
    }
  }

  onClickVideo = () => {
    const { video } = this.state
    if (video) {
      video.play()
    }
  }

  onClickTraining = () => {
    const { goToAgentTrainingCenter, handleHide } = this.props
    goToAgentTrainingCenter()
    handleHide()
  }

  render() {

    const modalCls = "HelpModal" + (this.state.videoOpen ? " HelpModal__video-open" : "")

    return (
      <Modal className={modalCls} show={this.props.show}>
        <Modal.Body>
          <div onClick={this.props.handleHide} className="HelpModal__image-close"/>
          <div className="HelpModal__body-header">Need help using Referral Manager?</div>
          <div className="HelpModal__body-text">
            Learn how to use your Referral Manager, find answers to commonly asked questions, and get tips and tricks for success.
          </div>
          <div className="HelpModal__body-centered">
            <div className="HelpModal__image-training-center"/>
            <OpButton className="HelpModal__body-button" onClick={this.onClickTraining}>Visit the Training Center</OpButton>
          </div>
          <hr/>
          <div className="HelpModal__body-header">Need a quick refresher on how it all works?</div>
          <div className="HelpModal__body-text">
            Watch our Demo Video for a refresher on how Opcity works, how to claim the leads and learn about our network partner program.
          </div>
          <div className="HelpModal__body-centered">
            <iframe type="text/html" width="560" height="315" src="https://www.youtube.com/embed/6am5tYoEVJs" allowFullScreen></iframe>
          </div>
          <hr/>
          <div className="HelpModal__body-header">Have any technical issues?</div>
          <div className="HelpModal__body-text">
            Visit our <a href="https://support.realtor.com/s/" target="_blank" rel="noopener noreferrer">Support Portal</a> to submit help requests.
          </div>

        </Modal.Body>
      </Modal>
    )
  }
}
const HelpModal = connectModal({ name: 'HelpModal', destroyOnHide: true })(Help)
export default HelpModal
